/**
 * EnquiryOptions
 * 
 * @Author: Focci
 * @Date: 2023-08-08 11:20:32
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-08 11:20:32
 */

import PropTypes from 'prop-types'
import MultipleCheckbox from '@comp/form/MultipleCheckbox'
import useFetch from '@hook/useFetch'
import { Skeleton } from '@comp/material'
import { filter, isArray, map } from 'lodash-es'
import { useCallback, useMemo, useState } from 'react'
import { Waypoint } from 'react-waypoint'

function EnquiryOptionsLoading() {
  return (
    <>
      <Skeleton style={{ width: '90%' }} />
      <Skeleton style={{ width: '90%' }} />
      <Skeleton style={{ width: '90%' }} />
      <Skeleton style={{ width: '90%' }} />
    </>
  )
}

export default function EnquiryOptions({
  type = '',
  wrapperClassName = 'min-h-[67px] grid grid-cols-2 gap-x-2 gap-y-1',
  onChange = () => {},
  title,
  ...multipleCheckboxProps
}) {
  const [requestApi, setRequestApi] = useState(false)
  const { data, isLoading } = useFetch(requestApi ? 'enquiry/spec-v2' : '', { type })

  const options = useMemo(() => {
    if(!isArray(data)) return []

    return map(data, (item) => ({ 
      label: item.question || item.ch, 
      value: item.field, 
      en: item.en 
    }))
  }, [data])

  const handleChange = useCallback((value) => {
    const { value: v } = multipleCheckboxProps
    const selectedOption = !isArray(value) ? (isArray(v) ? v : []) : value
    onChange({ 
      value,
      data: filter(options, (f) => selectedOption.indexOf(f.value) > -1) 
    })
  }, [multipleCheckboxProps, onChange, options])

  if(!isLoading && isArray(data) && data.length === 0) {
    return null
  }

  return (
    <>
      {title}
      <Waypoint onEnter={() => setRequestApi(true)}>
        <div className={wrapperClassName}>
          {isLoading && <EnquiryOptionsLoading />}
          {!isLoading && (
            <MultipleCheckbox
              {...multipleCheckboxProps}
              onChange={handleChange}
              options={options}
            />
          )}
        </div>
      </Waypoint>
    </>
  )
}

EnquiryOptions.propTypes = {
  type: PropTypes.string,
  wrapperClassName: PropTypes.string,
  onChange: PropTypes.func,
}
